'use client';

import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * DOM node вътре в .leftSidebar — пикърът се порталва тук, за да мине ref.contains() в
 * useClickOutside
 */
export const ColorPickerPortalContext = createContext(null);

const ColorPickerContext = createContext();

export const useColorPicker = () => {
  const context = useContext(ColorPickerContext);
  if (!context) {
    throw new Error('useColorPicker must be used within a ColorPickerProvider');
  }
  return context;
};

export const ColorPickerProvider = ({ children }) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);

  // window.colorPickerOpen трябва да се обновява СИНХРОННО преди следващия mousedown/touchstart,
  // иначе useClickOutside вижда false и затваря сайдбара докато ползваш react-colorful.
  const openColorPicker = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.colorPickerOpen = true;
    }
    setIsColorPickerOpen(true);
  }, []);

  const closeColorPicker = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.colorPickerOpen = false;
    }
    setIsColorPickerOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      isColorPickerOpen,
      openColorPicker,
      closeColorPicker,
    }),
    [isColorPickerOpen, openColorPicker, closeColorPicker],
  );

  return <ColorPickerContext.Provider value={value}>{children}</ColorPickerContext.Provider>;
};
